export const dataBindingBundlesConfig = {
    parts: false,
    components: true,
    host: true,
};
export const dataBindingConventions = {
    getComponentName: ({ componentName }) => `$w.${componentName}`,
    patterns: [
        {
            part: 'dataBindingPanel',
            path: '{,*/}%ComponentName%/editor/panels/dataBinding/%ComponentName%.dataBindingPanel.ts',
        },
    ],
};
//# sourceMappingURL=dataBinding.js.map